
import { put, call, takeEvery, select, takeLatest } from 'redux-saga/effects';
import * as actions from './actions';
import { Endpoints } from 'services/api';
import errorHandler from 'common/errorHandler';

function* getEventBusinessAreaApiKeys(api, eventId, itemOperation, pageKey) {
    try {
        let params = {
            operation: itemOperation
        };
        if (pageKey) {
            params.pageKey = pageKey
        }

        let result = yield call([api, api.get], `${Endpoints.events}/api/v1/events/${eventId}/businessareaapikeys`, {}, { params });
        return result.data;
    }
    catch (error) {
        if (error.isAxiosError) {
            if (error.response && error.response.status === 404) {
                return null;
            }
        }
        throw error;
    }
}

export function* getEventBusinessAreaApiKeysRequest(api, { eventId, itemOperation, pageKey }) {
    try {
        const apiKeysResult = yield call(getEventBusinessAreaApiKeys, api, eventId, itemOperation, pageKey);
        if (apiKeysResult && apiKeysResult.Items) {
            apiKeysResult.Items = apiKeysResult.Items.map((item, index) => {
                let businessAreaApiKey = item.data.apiKey;
                businessAreaApiKey.canAdd = false;
                businessAreaApiKey.canView = false;
                businessAreaApiKey.canEdit = false;
                businessAreaApiKey.canDelete = false;
                if (businessAreaApiKey.actions.includes("add")) {
                    businessAreaApiKey.canAdd = true;
                }
                if (businessAreaApiKey.actions.includes("view")) {
                    businessAreaApiKey.canView = true;
                }
                if (businessAreaApiKey.actions.includes("edit")) {
                    businessAreaApiKey.canEdit = true;
                }
                if (businessAreaApiKey.actions.includes("delete")) {
                    businessAreaApiKey.canDelete = true;
                }
                return item;
            });
        }
        yield put(actions.getEventBusinessAreaApiKeysSuccess(apiKeysResult));
    } catch (error) {
        let errorObject = errorHandler(error, "Get", "event business area api keys");
        yield put(actions.getEventBusinessAreaApiKeysFailure(errorObject));
    }
}

export function* watchGetEventBusinessAreaApiKeysRequest(api, { params }) {
    yield call(getEventBusinessAreaApiKeysRequest, api, params);
}

export default function* ({ api }) {
    yield takeLatest(actions.GET_EVENT_BUSINESS_AREA_API_KEYS_REQUEST, watchGetEventBusinessAreaApiKeysRequest, api);
}